// extracted by mini-css-extract-plugin
export var completeIcon = "VOa8I";
export var flagFilledColor = "a7Z3n";
export var flagIcon = "GR8ZG";
export var flagIconColor = "admf7";